define('lq/events/actions/azureAIDocumentFillerCommand',[
    'lq',
    'lq/events/actions/eventAction'
], function(lq, EventAction) {
    'use strict';

    var downloadDelayInMilliseconds = 500;

    function AzureAIDocumentFillerCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    };

    EventAction.extend(AzureAIDocumentFillerCommand, EventAction);

    AzureAIDocumentFillerCommand.typeName = 'AzureAIDocumentFillerCommand';

    AzureAIDocumentFillerCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    AzureAIDocumentFillerCommand.prototype.createEventActionRequest = function () {
       return {
            eventActionType: 'AzureAIDocumentFiller',
            command: this.eventData.command
        };
    };

    AzureAIDocumentFillerCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse && eventActionResponse.downloads && eventActionResponse.downloads.length)
            this.downloadFiles(eventActionResponse.downloads);

        continuation();
    };

    AzureAIDocumentFillerCommand.prototype.downloadFiles = function (downloads) {
        var self = this;
        downloads.forEach(function (download, index) {
            setTimeout(function () {
                self.downloadFile(download);
            }, index * downloadDelayInMilliseconds);
        });
    };

    AzureAIDocumentFillerCommand.prototype.downloadFile = function (download) {
        var route = download.isTemp ? "DynamicContent/DownloadTempFile" : "DynamicContent/DownloadFile";
        var url = this.piping.url.prepare(lq.getTenantUrl(route), {
            filename: download.filename,
            url: download.url,
            openInBrowser: false
        });

        var a = document.createElement('a');
        a.href = url;
        a.download = download.filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    return AzureAIDocumentFillerCommand;
});

